import { WprBaseConverter } from '../../../wpr-framework/view/convert/WprBaseConverter';


/**
 * 郵便番号コンバータ
 */
export class PostalCodeConverter extends WprBaseConverter {
	// コンストラクタ  -----------------------------------------------------------
	public constructor() {
		super('郵便番号');
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * 値変換処理
	 * @param value 値
	 * @returns 変換後の値
	 */
	public convert(value: any): string {
		try {
			let str1 = value.slice(0, 3);
			let str2 = value.slice(3);
			return str1 + '-' + str2;
		}
		catch (ex) {
			return value;
		}
	}
	// --------------------------------------------------------------------------
}